import { defaultClient as ApolloClient } from "@/main";
import {
  GET_MESSAGE_TEMPLATES
} from "../../../graphql/messageCenter/query";
import {
  TRIGGER_JOB,
  MESSAGE_TEMPLATES_MUTATE,
  MESSAGE_TEMPLATES_DELETE

} from "../../../graphql/messageCenter/mutation";
import router from "../../../router/router";

export const actions = {
  allMessageTemplates: async ({ commit }, payload) => {
    //use ApolloClient to fire graphql query
    return ApolloClient.query({
      query: GET_MESSAGE_TEMPLATES,
      variables: payload
    })
      .then(({ data }) => {
        //Get data from actions to state via mutations
        // commmit passes data from actions along to mutation function
        commit("setMessageTemplates", data.allMessageTemplates);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },

  messageTemplatesMerge: async ({ dispatch, commit }, payload) => {
    return ApolloClient.mutate({
      mutation: MESSAGE_TEMPLATES_MUTATE,
      variables: payload,
      update: (cache, { data }) => {
        try {
          // Log the entire mutation response for debugging
          console.log("Mutation response:", data);

          // Safely extract the node from the response
          const newNode = data.messageTemplatesMutate.edges.node;
          if (!newNode) {
            console.error("No node found in the mutation response");
            return;
          }

          // Read the current data from the Apollo cache
          const existingData = cache.readQuery({
            query: GET_MESSAGE_TEMPLATES
          });

          // Extract the list of current communications (nodes)
          let existingNodes = existingData.allMessageTemplates.edges.map(edge => edge.node);

          // Filter out the communication if it's being updated
          existingNodes = existingNodes.filter(comm => comm.seqNo !== newNode.seqNo);

          // Add the new or updated communication node
          existingNodes.push(newNode);

          // Wrap nodes back into edges for cache update
          const newData = {
            allMessageTemplates: {
              ...existingData.allMessageTemplates,
              edges: existingNodes.map(node => ({ node }))
            }
          };

          // Write the updated data back to Apollo cache
          cache.writeQuery({
            query: GET_MESSAGE_TEMPLATES,
            data: newData
          });

          // Commit to Vuex store to update the state
          commit("setMessageTemplates", newData.allMessageTemplates.edges.map(edge => edge.node));
        } catch (error) {
          console.error(`Error in messageTemplatesMerge update hook: ${error}`);
        }
      }
    })
      .then(() => {
        // Dispatch another action if needed (e.g., refetching or updating related state)
        dispatch("allMessageTemplates");
      })
      .catch(err => {
        console.error(`Error in messageTemplatesMerge action: ${err}`);
      });
  },

  messageTemplatesDelete: async ({ dispatch, commit }, { seqNo }) => {
    return ApolloClient.mutate({
      mutation: MESSAGE_TEMPLATES_DELETE,
      variables: { seqNo },
      update: (cache, { data }) => {
        try {
          // Log the mutation response
          console.log("Delete Mutation Response:", data);

          // Check if the mutation was successful
          const success = data.messageTemplatesDelete.success;
          if (!success) {
            console.error("Deletion was unsuccessful:", data.messageTemplatesDelete.message);
            return;
          }

          // Read current data from the Apollo cache
          const existingData = cache.readQuery({
            query: GET_MESSAGE_TEMPLATES
          });

          // Filter out the deleted communication from the existing nodes
          const updatedNodes = existingData.allMessageTemplates.edges.filter(
            edge => edge.node.seqNo !== seqNo
          );

          // Update the Apollo cache with the new data
          const newData = {
            allMessageTemplates: {
              ...existingData.allMessageTemplates,
              edges: updatedNodes
            }
          };

          // Write the updated data back to Apollo cache
          cache.writeQuery({
            query: GET_MESSAGE_TEMPLATES,
            data: newData
          });

          // Commit the updated data to the Vuex store
          commit("setMessageTemplates", newData.allMessageTemplates.edges.map(edge => edge.node));
        } catch (error) {
          console.error(`Error in messageTemplatesDelete update hook: ${error}`);
        }
      }
    })
      .then(() => {
        // Optionally dispatch another action (e.g., refetching the data or updating related state)
        dispatch("allMessageTemplates");
      })
      .catch(err => {
        console.error(`Error in messageTemplatesDelete action: ${err}`);
      });
  },
  triggerJob: async ({ commit }, payload) => {
    return ApolloClient.mutate({
      mutation: TRIGGER_JOB,
      variables: payload
    })
      .then(({ data }) => {
        if (data.triggerJob.success) {
          return { success: true, message: data.triggerJob.message, result: data.triggerJob.result };
        } else {
          console.error(`Trigger job failed: ${data.triggerJob.message}`);
          return { success: false, message: data.triggerJob.message };
        }
      })
      .catch(error => {
        console.error("Error in triggerJob action:", error);
        return { success: false, message: error.message || "Unknown error" };
      });
  }

};
